// removed by extract-text-webpack-plugin
module.exports = {"textContainer":"A_Pv","text":"_2thj"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LandingPage/Chart/Text/styles.scss
// module id = 454
// module chunks = 0